import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import kardiaOperationsLogo from '../../../assets/images/kardia_operations_logo.svg'
import Copyright from '../../../common/components/copyrights'
import useStyles from "./styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { authLogin } from '../../../store/actions/auth';
import { useDispatch } from "react-redux";
import { useSnackbar } from 'notistack';
import { email } from '../../../common/components/validations'
import * as MSG_CONSTANT from '../../../common/constants/messages'

const LoginPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // This function handled the form submit event
  async function handleLogin(e) {
    e.preventDefault()
    if (username && password) {
      closeSnackbar()
      setLoading(true);
      await dispatch(authLogin({ username, password },enqueueSnackbar));
      setLoading(false);
    }
    else { 
      closeSnackbar();
      enqueueSnackbar(MSG_CONSTANT.MESSAGES.EMAIL_PASSWORD, { variant: MSG_CONSTANT.MESSAGES.TYPE.error }); }
  }

  return (
    <Container component="main" maxWidth="xs" className={classes.loginContainer}>
      <CssBaseline />
      <div className={classes.paper}>
        <img src={kardiaOperationsLogo} alt="Kardia logo" />
        <Box mt={5}>
          <Typography component="h1" variant="h5" align="center">
            Login
          </Typography>
        </Box>
        <form className={classes.form} onSubmit={(e) => { handleLogin(e) }} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Email Address"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            error={emailError}
            onChange={(e) => {setUsername(e.target.value);setEmailError(email(e.target.value))}}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={loading}
          >
            {loading ? <CircularProgress  size='1rem'/> : 'Login'}
          </Button>
        </form>
      </div>
      <Box className={classes.loginFooter} mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default LoginPage;
